import { TemplateApiModel } from './template.model';

export type PointLabelStyleApiModel = {
  id: number;
  name: string;
  dateModified?: Date | null;
};

export type WithTemplates = PointLabelStyleApiModel & { templates: TemplateApiModel[] };

export enum PointLabelStyleRelationship {
  TEMPLATES = 'TEMPLATES',
}
